import React from 'react'

import Navbar from '../components/Navbar'
import Form from '../components/Form/Form'

import { formData, sendInfo } from '../data/motData'
import { motAnalysis } from '../helpers/analysis'

const Mot = () => {
    return (
        <div className="background">
            <Navbar />
            <Form formData={formData} sendInfo={sendInfo} analysis={motAnalysis} />
        </div>
    )
}

export default Mot